import { Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { GeneralParameters } from 'src/app/constants/general-parameters-constans';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { OrderStateEnums } from 'src/app/enum/order-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { OrderModel } from 'src/app/models/preliminaries/order.model';
import { OrderPrintModel } from 'src/app/models/print/preliminaries/order-print.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { OrderService } from 'src/app/services/preliminaries/order.service';
import { QuotationService } from 'src/app/services/preliminaries/quotation.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { AnnulOrderComponent } from '../annul-order/annul-order.component';

@Component({
  selector: 'app-register-order',
  templateUrl: './register-order.component.html',
  styleUrls: ['./register-order.component.scss'],
  standalone: false
})
export class RegisterOrderComponent implements OnInit {

  @ViewChild('annulOrderModal') annulOrderModalComponent?: CustomModalComponent | null = null;
  @ViewChild('attachFileOrder') attachFileOrderComponent?: CustomModalComponent | null = null;

  branchId: number = 0;
  clientStateId: number = ClientStateEnums.activo;
  companyId: number = 0;
  componentAnnulOrderModal = AnnulOrderComponent;
  componentAttachFiles = CustomAttachFilesComponent;
  constructionSiteStateId: number = ConstructionSiteStateEnums.activa;
  disableEnnulled: boolean = false;
  disableReverseState: boolean = false;
  disableState: boolean = false;
  disableAllDetail: boolean = false;
  disablePartial: boolean = false;
  disableOrderFromQuotation: boolean = false;
  filteredCostCenters: any[] = [];
  formOrder: FormGroup = new FormGroup({});
  iconState: string = 'pi pi-lock-open';
  inputsForAnnulOrderModals$ = new BehaviorSubject<any>({
    orderId: 0,
    disable: false
  });
  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: false
  });
  isCreatingOrderFromQuotation: boolean = false;
  isOpened: string | undefined = undefined;
  isSaveDisabled: boolean = false;
  listBranches: any[] = [];
  listClients: any[] = [];
  listCostCenters: any[] = [];
  listFiles: any[] = [];
  listSellers: any[] = [];
  listTypes: any[] = [];
  mainBranchByUser: BranchModel = new BranchModel();
  messageStateOrder: string = '';
  nameWindow: string = 'Captura Pedidos';
  orderContract: OrderModel = new OrderModel();
  orderId: number = 0;
  orderPrintModel: OrderPrintModel = new OrderPrintModel();
  orderStateOpen: number = OrderStateEnums.open;
  outputForAttachFiles$ = new Subject<any>();
  permissionPrint: boolean = true;
  permissionUpdatable: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  quotationConsecutive: string = '';
  reloadPrint: boolean = false;
  severityState: string = "danger";
  stateText: string = 'Abierto';
  subscription: Subscription;
  swMandatoryQuotation: boolean = false;
  swQuotation: boolean = false;
  swReservation: boolean = false;
  swShowOnlyOrderBreakdown: boolean = false;
  titleState: string = '';
  url: string = 'order';
  userAuthenticated: UserModel = new UserModel();

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private cdr: ChangeDetectorRef,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private invoiceService: InvoiceService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private orderService: OrderService,
    private quotationService: QuotationService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(new OrderModel());
  }

  async ngOnInit() {
    await this.getGeneralParametersByCompany();
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.orderId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.handleInitialState();

    this.subscription = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async createNewOrder() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para crear pedido. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.orderId = 0;
    this.disableAllDetail = true;
    this.orderContract = new OrderModel();
    this.orderContract.branchId = this.branchId;
    this.quantityDetails = 0;
    await this.validateForm(this.orderContract);
    this.location.replaceState(`/${this.url}/register`);
    this.toggleCreatingOrderFromQuotation()
  }

  toggleCreatingOrderFromQuotation() {
    if (this.swQuotation && this.swMandatoryQuotation) {
      this.isCreatingOrderFromQuotation = !this.isCreatingOrderFromQuotation;
    }
  }

  changeDate(date: Date | null) {
    const previusDate = this.dateConverterService.convertUtcToLocalDate(this.orderContract.dateOrder);
    if ((this.quantityDetails != 0) && (date != previusDate)) {
      this.toastHandlerService.showToast(
        'warning',
        'No se puede cambiar la fecha si el pedido tiene detalle.'
      );
      setTimeout(() => this.formOrder.controls["dateOrder"].patchValue(previusDate));
    }
  }

  changeType(orderTypeId: number) {
    const previousOrderTypeId = this.orderContract.orderTypeId;
    if ((this.quantityDetails != 0) && (orderTypeId != previousOrderTypeId)) {
      this.toastHandlerService.showToast(
        'warning',
        'No se puede cambiar el tipo si el pedido tiene detalle.'
      );
      setTimeout(() => this.formOrder.controls["orderTypeId"].patchValue(previousOrderTypeId), 100);
    }
  }

  async changeState() {
    if (!this.orderId || this.orderId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un pedido.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para modificar el estado del pedido. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    try {
      const response = await firstValueFrom(this.orderService.setStateOrder(this.orderId));
      this.orderContract = response;
      this.validateForm(this.orderContract);
      this.toastHandlerService.showToast(
        'success',
        'El estado del pedido fue modificado exitosamente.'
      );
    } catch (error) {
      console.error('Error al modificar el estado del pedido.', error);
    }
  }

  async changeConsecutive() {
    const branchId = this.formOrder.get("branchId")?.value;
    let consecutive = this.formOrder.get("consecutive")?.value;
    if (this.orderContract.consecutive == consecutive) {
      return;
    }
    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }
    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      return;
    }
    try {
      this.orderContract = await firstValueFrom(this.orderService.getOrderByKeysAsync(branchId, consecutive));
      this.orderId = this.orderContract.orderId;
      await this.validateForm(this.orderContract);
      this.location.replaceState(`/${this.url}/register/${this.orderId}`);
    } catch (error) {
      console.error('Error al buscar el pedido por campos de recuperación.', error);
    }
  }

  async deleteFile(file: any) {
    if (this.orderContract.orderId != 0) {
      const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar el adjunto seleccionado?');
      if (accepted) {
        try {
          await firstValueFrom(this.orderService.deleteFilesToOrder(this.orderContract.orderId, file));
          this.toastHandlerService.showToast(
            'success',
            'El adjunto fue eliminado exitosamente'
          );
          this.getFilesToOrder();
        } catch (error) {
          console.error('Error catch:', error);
        }
      }
    }
  }

  async deleteOrder() {
    if (this.orderContract.orderId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        `Debe crear el encabezado del pedido.`
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para eliminar el pedido. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar el pedido actual?');

    if (!accepted) return;
    try {
      await firstValueFrom(this.orderService.deleteOrder(this.orderId));
      this.toastHandlerService.showToast(
        'success',
        'El pedido fue eliminado exitosamente.'
      );
      this.createNewOrder();
    } catch (error) {
      console.error('Error al eliminar el pedido.', error);
    }
  }

  downloadFile(fileName: any) {
    if (this.orderContract.orderId != 0) {
      this.orderService.downloadFileToOrder(this.orderContract.orderId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  finishLoading(finishPrint: boolean) {
    if (finishPrint) {
      window.print();
    }
  }

  async getAllLists() {
    try {
      const [branches, clients, sellers, types, costCenters] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.orderService.getAllClientsForSelectAsync()),
        firstValueFrom(this.orderService.getAllSellersForSelect(this.branchId)),
        firstValueFrom(this.orderService.getAllOrderTypesForSelect()),
        firstValueFrom(this.orderService.getAllCostCentersForSelect(this.branchId)),
      ]);
      this.listBranches = branches;
      this.listClients = clients;
      this.listSellers = sellers;
      this.listTypes = types;
      this.listCostCenters = costCenters;
      this.filteredCostCenters = this.listCostCenters;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getAssociatedQuotationAsync(quotationId: number | null) {
    if (!quotationId) {
      this.quotationConsecutive = '';
      return;
    }

    try {
      const quotation = await firstValueFrom(this.quotationService.getQuotationById(quotationId));
      if (this.orderContract.quotationId !== quotationId) return;
      this.quotationConsecutive = quotation?.consecutive ? quotation.consecutive.toString() : '';
    } catch (error) {
      if (this.orderContract.quotationId !== quotationId) return;
      console.error('Error al buscar la cotización asociada al pedido.', error);
      this.quotationConsecutive = '';
    }
  }

  async getNewOrder(orderId: number) {
    this.orderId = orderId;
    await this.reloadOrder(true);
  }

  async getButtonClick(buttonClick: any) {
    let consecutive = this.formOrder.get("consecutive")?.value;
    const branchId = this.formOrder.get("branchId")?.value;
    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }
    consecutive = consecutive === 0 ? null : consecutive;
    await this.handleOrderNavigation(buttonClick, branchId, consecutive);
  }

  async getBranch(branchId: number | null, reload: boolean) {
    let validBranch = null;
    if (branchId != null) {
      const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
      if (branch) {
        validBranch = branchId;
      }
    }
    this.branchId = validBranch ?? 0;
    await this.getAllLists();
    if (reload) {
      this.createNewOrder();
    }
  }

  async getCostCenter(costCenterId: number | null, isInitialLoad: boolean) {
    try {
      const hasDetails = this.quantityDetails > 0;
      const previousCostCenterId = this.orderContract.costCenterId;
      if (!isInitialLoad && hasDetails) {
        if (!costCenterId) {
          this.toastHandlerService.showToast(
            'error',
            'No puede limpiar el centro de costos si el pedido tiene detalle.'
          );
        } else if (costCenterId !== previousCostCenterId) {
          this.toastHandlerService.showToast(
            'error',
            'No puede cambiar el centro de costos si el pedido tiene detalle.'
          );
        }
        setTimeout(() => this.formOrder.controls["costCenterId"].patchValue(previousCostCenterId));
        return;
      }
      if (!costCenterId) {
        const clientId = this.formOrder.get("clientId")?.value;
        this.formOrder.patchValue({ costCenterId: null, sellerId: null });
        this.filteredCostCenters = this.listCostCenters.filter(cc => !clientId || cc.clientId === clientId);
        return;
      }
      const response = await firstValueFrom(this.orderService.getCostCenterByIdForRegister(costCenterId));
      if (!isInitialLoad && (response.constructionSiteStateId == ConstructionSiteStateEnums.inactiva)) {
        this.toastHandlerService.showToast(
          'warning',
          'El centro de costos seleccionado se encuentra inactivo.'
        );
        this.formOrder.patchValue({ clientId: null, costCenterId: null, sellerId: null });
        this.filteredCostCenters = this.listCostCenters;
        return;
      }
      this.getSeller(response.sellerId, false);
      this.constructionSiteStateId = response.constructionSiteStateId;
      this.clientStateId = response.clientStateId;
      setTimeout(() => this.formOrder.controls["costCenterId"].patchValue(costCenterId));
      this.filteredCostCenters = this.listCostCenters.filter(cc => cc.clientId === response.clientId);
      if (this.formOrder.get("clientId")?.value !== response.clientId) {
        this.formOrder.controls["clientId"].patchValue(response.clientId);
      }
    } catch (error) {
      console.error('Error al obtener el centro de costos con Id.', error);
    }
  }

  async getClient(clientId: number | null) {
    try {
      const hasDetails = this.quantityDetails > 0;
      const previousClientId = this.orderContract.costCenter?.clientId;
      if (hasDetails) {
        if (!clientId) {
          this.toastHandlerService.showToast(
            'error',
            'No puede limpiar el cliente si el pedido tiene detalle.'
          );
        } else if (clientId !== previousClientId) {
          this.toastHandlerService.showToast(
            'error',
            'No puede cambiar el cliente si el pedido tiene detalle.'
          );
        }
        setTimeout(() => this.formOrder.controls["clientId"].patchValue(previousClientId));
        return;
      }
      if (!clientId) {
        this.filteredCostCenters = this.listCostCenters;
        this.formOrder.patchValue({ costCenterId: null, sellerId: null });
        return;
      }
      if (clientId !== previousClientId) {
        this.formOrder.patchValue({ costCenterId: null, sellerId: null });
      }
      this.filteredCostCenters = this.listCostCenters.filter(cc => cc.clientId === clientId);
      const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));
      this.clientStateId = client.clientStateId;
      if (this.clientStateId == ClientStateEnums.inactivo) {
        this.toastHandlerService.showToast(
          'warning',
          'El cliente seleccionado se encuentra inactivo.'
        );
        this.formOrder.patchValue({ clientId: null, costCenterId: null, sellerId: null });
        this.filteredCostCenters = this.listCostCenters;
        return;
      }
    } catch (error) {
      console.error('Error al obtener el cliente con id.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      this.mainBranchByUser = await firstValueFrom(this.userAuthenticatedService.branchObservable
        .pipe(filter(branch => branch && branch.branchId !== 0)));
      this.branchId = this.mainBranchByUser.branchId;
      this.companyId = this.mainBranchByUser.companyId;
      await this.getAllLists();
    } catch (error) {
      console.error('Error al obtener la sucursal principal del usuario autenticado.', error);
    }
  }

  async getFilesToOrder() {
    try {
      this.listFiles = await firstValueFrom(this.orderService.getFilesToOrder(this.orderId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getGeneralParametersByCompany() {
    this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swQuotation = response.some(x => x.name === GeneralParameters.quotationsModule);
      this.swMandatoryQuotation = response.some(x => x.name === GeneralParameters.requireQuotationForOrder);
      this.swReservation = response.some(x => x.name === GeneralParameters.swReservation);
      this.swShowOnlyOrderBreakdown = response.some(x => x.name === GeneralParameters.swShowOnlyOrderBreakdown);
    });
  }

  async getSeller(sellerId: number | null, change: boolean) {
    const previousSellerId = this.orderContract.sellerId;
    if (change) {
      if (sellerId != null && sellerId != 0) {
        if (previousSellerId != sellerId && (this.quantityDetails != 0)) {
          const accepted = await this.confirmDialogService.confirm(
            'El pedido tiene artículos asociados. ¿Realmente desea modificar el vendedor?'
          );
          if (!accepted) {
            setTimeout(() => this.formOrder.controls["sellerId"].setValue(previousSellerId));
          }
        }
      } else if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'error',
          'No puede limpiar el vendedor si el pedido tiene detalle.'
        );
        setTimeout(() => this.formOrder.controls["sellerId"].setValue(previousSellerId));
      }
    } else {
      setTimeout(() => this.formOrder.controls["sellerId"].setValue(sellerId));
    }
  }

  async handleInitialState() {
    if (this.orderId !== null && this.orderId !== 0) {
      await this.getOrderById();
    } else {
      await this.getFirstBranchByUserAuthenticatedAsync();
      this.createNewOrder();
    }
  }

  private async handleOrderNavigation(buttonClick: any, branchId: number, consecutive: number) {
    const actionMap: Record<string, () => Promise<OrderModel>> = {
      first: () =>
        firstValueFrom(this.orderService.getFirstOrderByKeysAsync(branchId)),
      next: () =>
        firstValueFrom(this.orderService.getNextOrderByKeysAsync(branchId, consecutive)),
      previus: () =>
        firstValueFrom(this.orderService.getPreviusOrderByKeysAsync(branchId, consecutive)),
      last: () =>
        firstValueFrom(this.orderService.getLastOrderByKeysAsync(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.orderContract = new OrderModel();
      this.orderContract.branchId = branchId;
      this.validateForm(this.orderContract);
      return;
    }
    try {
      const suspension = await action();
      this.orderContract = suspension;
      this.orderId = suspension.orderId;
      this.validateForm(this.orderContract);
      this.location.replaceState(`/${this.url}/register/${this.orderId}`);
    } catch (error) {
      console.error(`Error al buscar el pedido (${buttonClick.target.id}).`, error);
    }
  }

  async getOrderById() {
    try {
      this.orderContract = await firstValueFrom(this.orderService.getOrderById(this.orderId));
      this.orderId = this.orderContract.orderId;
      this.branchId = this.orderContract.branchId;
      await this.getAllLists();
      this.cdr.detectChanges();
      await this.validateForm(this.orderContract);
    } catch (error) {
      console.error('Error al buscar el pedido.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      await this.getPermissionsForUserByWindow();
      await Promise.all([
        this.getPermissionPrint(),
        this.getPermissionProfileByUrl()
      ]);
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      if (!this.permissionUpdatable) { this.formOrder.disable(); }
    } catch (error) {
      console.error('Error al obtener el permiso actualizable.', error);
    }
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await this.getPermissionOrder(OptionWindow.imprimir);
      if (this.orderId != 0) {
        await this.getOrderById();
      }
    } catch (error) {
      console.error('Error al obtener el permiso de impresión.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    try {
      this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user &&
        user.userId !== 0)));
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Order));
      this.companyId = this.userAuthenticated.companyId;
    } catch (error) {
      console.error('Error al obtener los permisos del usuario para la ventana de pedidos.', error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate([`/${this.url}`]);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  async openAnnulOrderModal() {
    const conceptId = this.orderContract.conceptId;
    if (!this.orderId && this.orderId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un pedido.'
      );
      return;
    }
    if (conceptId) {
      this.openAnnulModal(this.orderId, true);
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para modificar los estados del pedido. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    try {
      const response = await this.getPermissionOrder(OptionWindow.anular);
      if (!response) {
        this.toastHandlerService.showToast(
          'warning',
          `El usuario no tiene permisos para anular pedidos. Comuníquese con el administrador del sistema.`
        );
        return;
      }
    } catch (error) {
      console.error('Error al obtener el permiso para anular pedidos.', error);
    }
    const accepted = await this.confirmDialogService.confirm('¿Realmente desea Anular el pedido actual?');
    if (accepted) {
      this.openAnnulModal(this.orderId, false);
    }
  }

  private openAnnulModal(orderId: number, disable: boolean) {
    this.inputsForAnnulOrderModals$.next({
      orderId,
      disable
    });
    this.annulOrderModalComponent?.show();
  }


  async openAttachFile() {
    if (this.orderContract.orderId != 0 && this.orderContract.orderId != null) {
      await this.getFilesToOrder();
      this.attachFileOrderComponent && this.attachFileOrderComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un pedido.'
      );
    }
  }

  async printPage() {
    if (this.orderContract.orderStateId === OrderStateEnums.open) {
      this.toastHandlerService.showToast(
        'warning',
        `Solo es posible imprimir cuando el estado es Cierre inicial o Cierre final.`
      );
      return;
    }
    if (!this.orderContract.orderId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un pedido.'
      );
      return;
    }
    if (!this.permissionPrint) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para imprimir pedidos. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.toastHandlerService.clearAllToasts();
    try {
      this.orderPrintModel = await firstValueFrom(this.orderService.getOrderByKeysByPrintAsync(this.orderContract.branchId, 0,
        this.orderContract.orderId));
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error('Error al imprimir el pedido.', error);
    }
  }

  async getPermissionOrder(option: OptionWindow): Promise<boolean> {
    try {
      return await firstValueFrom(this.orderService.getPermissionOrder(option));
    } catch (error) {
      console.error(`Error al validar el permiso para la opción ${option}.`, error);
      return false;
    }
  }

  async revertState() {
    if (this.permissionUpdatable) {
      const response = await this.getPermissionOrder(OptionWindow.abrir);
      if (response) {
        try {
          const response = await firstValueFrom(this.orderService.revertOrderState(this.orderId));
          this.orderContract = response;
          this.validateForm(this.orderContract);
          this.toastHandlerService.showToast(
            'success',
            'El estado del pedido fue modificado exitosamente.'
          );
        } catch (error) {
          console.error('Error al reversar el estado del pedido.', error);
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          `El usuario no tiene permisos para reversar los estados del pedido. Comuníquese con el administrador del sistema.`
        );
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para modificar el estado del pedido. Comuníquese con el administrador del sistema.`
      );
    }
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.orderId != 0 && this.orderId != null) {
      this.router.navigate([`/${this.url}/register/`, this.orderId]);
    } else {
      this.router.navigate([`/${this.url}/register`]);
    }
  }

  async reloadOrder(reload: boolean) {
    if (reload) {
      await this.getOrderById();
    }
  }

  async send() {
    this.validateFormControls();
    if (this.formOrder.valid) {
      //Hago enable el campo de tipo de entrada para que me permita guardarlo:
      this.formControlStateService.setControlState(this.formOrder,
        ['consecutive', 'orderTypeId'], true);
      const modelOrder = this.formOrder.value as OrderModel;
      //Hago null, los campos que permiten ser nulos:
      if (modelOrder.conceptId == 0) modelOrder.conceptId = null;
      if (modelOrder.observation == "") modelOrder.observation = null;
      if (modelOrder.observationAnnul == "") modelOrder.observationAnnul = null;
      if (modelOrder.purchaseOrderNumber == "") modelOrder.purchaseOrderNumber = null;
      if (modelOrder.observationRemission == "") modelOrder.observationRemission = null;
      if (modelOrder.observationCommercial == "") modelOrder.observationCommercial = null;
      if (this.orderId == 0) {
        try {
          this.orderContract = await firstValueFrom(this.orderService.createOrder(modelOrder));
          this.toastHandlerService.showToast(
            'success',
            'El pedido fue creado exitosamente.'
          );
          this.orderId = this.orderContract.orderId;
          this.validateForm(this.orderContract);
          this.location.replaceState(`/${this.url}/register/${this.orderId}`);
        } catch (error) {
          console.error('Error al crear el pedido.', error);
        }
      } else {
        this.orderContract.sellerId = modelOrder.sellerId;
        this.orderContract.dateOrder = modelOrder.dateOrder;
        this.orderContract.conceptId = modelOrder.conceptId;
        this.orderContract.advertiser = modelOrder.advertiser;
        this.orderContract.observation = modelOrder.observation;
        this.orderContract.orderTypeId = modelOrder.orderTypeId;
        this.orderContract.orderStateId = modelOrder.orderStateId;
        this.orderContract.costCenterId = modelOrder.costCenterId;
        this.orderContract.observationAnnul = modelOrder.observationAnnul;
        this.orderContract.purchaseOrderNumber = modelOrder.purchaseOrderNumber;
        this.orderContract.observationRemission = modelOrder.observationRemission;
        this.orderContract.observationCommercial = modelOrder.observationCommercial;
        try {
          this.orderContract = await firstValueFrom(this.orderService.updateOrder(this.orderContract));
          this.toastHandlerService.showToast(
            'success',
            'El pedido fue modificado exitosamente.'
          );
          this.validateForm(this.orderContract);
        } catch (error) {
          console.error('Error al actualizar el pedido.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo sucursal es obligatorio.',
        min: 'Debes seleccionar una sucursal válida.'
      },
      costCenterId: {
        required: 'El campo centro de costos es obligatorio.',
        min: 'Debes seleccionar un centro de costos válido.'
      },
      dateOrder: {
        required: 'El campo fecha es obligatorio.'
      },
      orderStateId: {
        required: 'El campo estado es obligatorio.'
      },
      orderTypeId: {
        required: 'El campo tipo es obligatorio.'
      },
      sellerId: {
        required: 'El campo vendedor es obligatorio.',
        min: 'Debes seleccionar un vendedor válido.'
      },
      observation: {
        maxlength: 'El campo observación permite máximo 250 .'
      },
      observationRemission: {
        maxlength: 'El campo observación remisión permite máximo 250 .'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formOrder.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  updateFormState(): void {
    const stateConfig: Record<string, {
      icon: string;
      title: string;
      text: string;
      severity: string;
      disableState: boolean;
      isSaveDisabled: boolean;
      disablePartial: boolean;
      disableEnnulled: boolean;
      disableAllDetail: boolean;
      enableConsecutive: boolean;
      disableReverseState: boolean;
      disableOrderFromQuotation: boolean;
    }> = {
      [OrderStateEnums.open]: {
        icon: 'pi pi-lock-open',
        title: 'Cierre (Inicial)',
        text: 'Abierta',
        severity: 'danger',
        disableState: false,
        isSaveDisabled: false,
        disableEnnulled: false,
        disableAllDetail: false,
        disableReverseState: true,
        disablePartial: this.orderId == 0,
        enableConsecutive: this.orderId !== 0,
        disableOrderFromQuotation: false,
      },
      [OrderStateEnums.initialClose]: {
        icon: 'pi pi-lock',
        title: 'Cierre (Final)',
        text: 'Cierre (Inicial)',
        severity: 'info',
        disableState: false,
        isSaveDisabled: true,
        disablePartial: true,
        disableEnnulled: false,
        disableAllDetail: false,
        enableConsecutive: true,
        disableReverseState: false,
        disableOrderFromQuotation: true
      },
      [OrderStateEnums.finalClose]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cierre (Final)',
        severity: 'success',
        disableState: true,
        isSaveDisabled: true,
        disablePartial: true,
        disableAllDetail: true,
        disableEnnulled: false,
        enableConsecutive: true,
        disableReverseState: false,
        disableOrderFromQuotation: true
      },
      [OrderStateEnums.annulled]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Anulado',
        severity: 'warn',
        disableState: true,
        isSaveDisabled: true,
        disablePartial: true,
        disableEnnulled: true,
        disableAllDetail: true,
        enableConsecutive: true,
        disableReverseState: false,
        disableOrderFromQuotation: true
      }
    };

    const currentState = this.orderContract.orderStateId;
    const config = stateConfig[currentState];
    if (!config) return;
    this.stateText = config.text;
    this.iconState = config.icon;
    this.titleState = config.title;
    this.severityState = config.severity;
    this.disableState = config.disableState;
    this.isSaveDisabled = config.isSaveDisabled;
    this.disablePartial = config.disablePartial;
    this.disableEnnulled = config.disableEnnulled;
    this.disableAllDetail = config.disableAllDetail;
    this.disableReverseState = config.disableReverseState;
    this.disableOrderFromQuotation = config.disableOrderFromQuotation;

    this.formOrder.disable();
    if (!config.isSaveDisabled) {
      this.formOrder.enable();
      const control = this.formOrder.get('consecutive');
      config.enableConsecutive ? control?.enable() : control?.disable();
    } else {
      this.formControlStateService.setControlState(this.formOrder, ['branchId', 'consecutive'], true);
    }
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.orderService.attachFilesToOrder(this.orderId, formData));
      await this.getFilesToOrder();
      this.toastHandlerService.showToast(
        'success',
        'Se adjunto el archivo exitosamente'
      );
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.orderContract.consecutive,
      disabled: this.orderContract.orderStateId != OrderStateEnums.open
    });
  }

  validateFormControls() {
    Object.keys(this.formOrder.controls).forEach((key) => {
      const control = this.formOrder.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }

  async validateForm(order: OrderModel) {
    this.formOrder = this.formBuilder.group({
      clientId: [0],
      advertiser: [order.advertiser],
      consecutive: [order.consecutive],
      purchaseOrderNumber: [order.purchaseOrderNumber],
      observationCommercial: [order.observationCommercial],
      orderStateId: [order.orderStateId, [Validators.required]],
      observation: [order.observation, [Validators.maxLength(250)]],
      branchId: [order.branchId, [Validators.required, Validators.min(1)]],
      sellerId: [order.sellerId, [Validators.required, Validators.min(1)]],
      orderTypeId: [order.orderTypeId, [Validators.required, Validators.min(1)]],
      costCenterId: [order.costCenterId, [Validators.required, Validators.min(1)]],
      observationRemission: [order.observationRemission, [Validators.maxLength(250)]],
      dateOrder: [order.dateOrder ? this.dateConverterService.convertUtcToLocalDate(order.dateOrder)
        : null, [Validators.required]],
    });
    await Promise.all([
      this.getCostCenter(order.costCenterId, true),
      this.updateFormState(),
      this.getAssociatedQuotationAsync(order.quotationId)
    ]);
  }
}
